import { type ReactNode } from 'react';
import WithoutAdsIcon from '@assets/img/icons/without-ads.svg?react';
import { type TFunction } from 'i18next';

import { CircledCash } from '@/components/ui/CircledCash/CircledCash';
import { VipIcon } from '@/components/ui/Icons';
import { Picture } from '@/components/ui/Picture/Picture';

import { convertRemToPixels } from '../lib/convertRemtoPx';

import cashPng from '/img/icons/cash.png';
import cashWebp from '/img/icons/cash.webp';
import folderPng from '/img/icons/custom_contract/folder.png';
import folderWebp from '/img/icons/custom_contract/folder.webp';
import flashPng from '/img/icons/flash.png';
import flashWebp from '/img/icons/flash.webp';
import tgemPng from '/img/icons/gems.png';
import tgemWebp from '/img/icons/gems.webp';
import usdPng from '/img/icons/usd.png';
import usdWebp from '/img/icons/usd.webp';

const transKeyObj: Record<number, (t: TFunction) => string> = {
  0: (t) => `${t('Bonuses and boosts')} <span>${t('with no ads')}</span>`,
  1: (t) => `<span>+10%</span> Cash ${t('for contracts')}`,
  2: (t) => `<span>${t('Free 12-Hour VIP')}</span> ${t('every Monday')}`,
};

const icons: Record<number, () => ReactNode> = {
  0: (): ReactNode => <WithoutAdsIcon className="w-8 h-8" />,
  1: (): ReactNode => (
    <CircledCash
      className="w-8 h-8"
      cashIconSize={convertRemToPixels(1.5625)}
    />
  ),
  2: (): ReactNode => <VipIcon className="w-8 h-8" />,
};

const shopIcons: Record<number, () => ReactNode> = {
  3: (): ReactNode => (
    <Picture
      alt="flesh"
      img={flashPng}
      webp={flashWebp}
      className="size-8 min-w-8"
    />
  ),
  0: (): ReactNode => (
    <Picture
      alt="cash"
      img={cashPng}
      webp={cashWebp}
      className="size-8 min-w-8"
    />
  ),
  1: (): ReactNode => (
    <Picture alt="usd" img={usdPng} webp={usdWebp} className="size-8 min-w-8" />
  ),
  2: (): ReactNode => (
    <Picture
      alt="tgem"
      img={tgemPng}
      webp={tgemWebp}
      className="size-8 min-w-8"
    />
  ),
  4: (): ReactNode => (
    <Picture
      alt="folder"
      img={folderPng}
      webp={folderWebp}
      className="size-8 min-w-8"
    />
  ),
  5: (): ReactNode => <VipIcon className="size-8 min-w-8" />,
  6: (): ReactNode => <WithoutAdsIcon className="size-8 min-w-8" />,
};

const shopTransKeyObjBenefits: Record<number, (t: TFunction) => string> = {
  0: (t) => `<span>+10%</span> CASH <br> ${t('for contracts')}`,
  1: (t) => `<span>+5%</span> in USD <br> ${t('from Partners')}`,
  2: (t) => `<span>x2</span> T-Gem & CASH <br> ${t('from Partners')}`,
  3: (t) => `<span>+15</span> ${t('Charges')} <br> ${t('in Roll Craft')}`,
  4: (t) => `<span>${t('Free')}</span> ${t('Custom')} <br> ${t('Contract')}`,
  5: (t) =>
    `<span>${t('Status')}</span> ${t('in the Arena')} <br> ${t('and in the Office')}`,
  6: (t) => `<span>${t('With no ADS')}</span> <br> ${t('Bonuses and boosts')}`,
};

export const vipBenefitsConfig = {
  transKeyObj,
  icons,
  shopTransKeyObjBenefits,
  shopIcons,
};
